// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KWNU0","controls":"styles_controls__2OH1B","charLimit":"styles_charLimit__3Gkrz","input":"styles_input__2AC3O","send":"styles_send__3yITH"};